export default "__VITE_ASSET__B4aYXPIn__"